<template>
    <!-- Single post-->
      <section class="section section-lg bg-default novi-background bg-cover">
        <!-- section wave-->
        <div class="container container-wide">
          <div class="row justify-content-sm-center">
            <div class="col-lg-10 col-xl-8 col-xxl-6 sections-collapsable single-post-wrap table-containers">
              <article class="post-blog-article">
                <div class="tokusho-logo" id="logo-top">
                    <div><img class="logo pmark-logo" @click="redirect('pmark_logo_click', 'https://privacymark.jp')" src="/images/eowp/pmark.png" /></div>
                    <div class="tokusho-logo-description">
                        株式会社アルクはプライバシーマーク付与事業者です。
                    </div>
                </div>
                <ul class="post-blog-article-meta group-xl">
                  <li>
                    <div class="box-inline"><span class="icon novi-icon icon-md icon-primary mdi mdi-seal"></span>
                      特定商取引に関する法律に基づく表示
                    </div>
                  </li>
                </ul>
                <ul class="list-content">
                    <li><span>販売業者<br />株式会社アルク</span></li>
                    <li><span>運営責任者<br />畔上 剛</span></li>
                    <li><span>お問い合わせ先<br /><a href="https://eow-support.alc.co.jp/hc/ja/requests/new" @click="redirect('inquiry_link1_click', 'https://eow-support.alc.co.jp/hc/ja/requests/new')">お問い合わせフォーム</a></span></li>
                    <li><span>所在地<br />{{ShopConstants.COMPANY_ADDRESS}}</span></li>
                    <li><span>商品の販売価格<br /><a href="#" @click="redirect('tokusho_product_link_click', '/products')">商品ページ</a>に記載しています。期間（コース）により価格は異なります。</span></li>
                    <li><span>商品代金以外に必要な料金<br />消費税 （商品紹介ページ内の表示は税込価格です）</span></li>
                    <li><span>お支払い方法・お支払時期<br />クレジットカード<br />決済代行会社：Stripe<br />※締日および引落日は、お使いのクレジットカード発行元の規定に準じます。<br />※クレジットカード決済にかかる手数料は、アルクが負担します。</span></li>
                    <li><span>ご利用開始時期（引き渡し期間）<br />お申し込み・カード決済の完了次第、直ちにご利用いただけます。</span></li>
                    <li><span>ご利用停止<br /><a href="#" @click="redirect('tokusho_account_link_click', '/account')">アカウントページ</a>から、ご自身でお手続きください。</span></li>
                    <li><span>返金・キャンセル<br />サービスの性質上、お客様都合による返品・キャンセルはできません。弊社「<a href="https://eow-support.alc.co.jp/hc/ja/requests/new" @click="redirect('inquiry_link2_click', 'https://eow-support.alc.co.jp/hc/ja/requests/new')">お問い合わせフォーム</a>」までご連絡ください。</span></li>
                    <li>
                        <span>動作保障環境<br />弊社で通常動作確認を行っているブラウザーの一覧は以下のとおりです。</span>
                        <ul class="sub-list-content">
                            <li><span>{{ShopConstants.COMPATIBLE_OS_BROWSERS_WINDOWS}}</span></li>
                            <li><span>{{ShopConstants.COMPATIBLE_OS_BROWSERS_MACOS}}</span></li>
                            <li><span>{{ShopConstants.COMPATIBLE_OS_BROWSERS_IOS}}</span></li>
                            <li><span>{{ShopConstants.COMPATIBLE_OS_BROWSERS_ANDROID}}</span></li>
                        </ul>
                        <span>※Android携帯のみの対応となっており、タブレットからはスマートフォン版をご利用いただけない場合がございます。</span><br>
                        <span>※ブラウザーやOSのバージョンは変更される可能性があります。ご利用環境に関する詳細は、FAQページにてご確認ください。</span>
                    </li>
                </ul>

                <div class="tokusho-logo-bottom">
                    <div><img class="logo pmark-logo" @click="redirect('pmark_logo_click', 'https://privacymark.jp')" src="/images/eowp/pmark.png" /></div>
                    <div class="tokusho-logo-description">
                        株式会社アルクはプライバシーマーク付与事業者です。
                    </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 1111px){
    .section .tokusho-logo{
        display: none!important;
    }
    .tokusho-logo-bottom{
        float: right!important;
        padding-bottom: 90px!important;
        display: flex!important;
        padding-top: 40px!important;
    }
}
section div.table-containers{
    max-width: 83.33333%!important;
    flex: 0 0 83.33333%!important;
}
@media screen and (max-width: 991px){
    section div.table-containers{
        max-width: 100%!important;
        flex: 0 0 auto!important;
        padding-right: 20px!important;
    }
}
.pmark-logo{
    width: 30%!important;
    margin-right: 275px;
}
.logo{
    cursor: pointer!important;
}
.tokusho-logo-description{
    display: block;
    position: absolute;
    margin-top: 33%!important;
}
.tokusho-logo{
    position: relative!important;
    display: flex!important;
    float: right!important;
    width: auto!important;
    max-width: 460px!important;
}
.tokusho-logo-bottom{
    position: relative!important;
    display: none;
    float: right!important;
    width: auto!important;
    max-width: 460px!important;
}
.box-inline{
    font-size: 22px!important;
    padding-bottom: 10px!important;
}
.box-inline span{
    font-size: 35px!important;
}
a{
    color: blue;
    font-weight:bold;
    line-break:strict;
}
.sub-list-content{
    padding-left: 33px!important;
    padding-top: 15px;
    padding-bottom: 5px;
}
.sub-list-content li{
    list-style-type: disc!important;
    display: list-item!important;
    font-size: 15px!important;
    padding-bottom: 8px!important;
    line-height: 20px!important;
}
.sub-list-content li span{
    position: relative!important;
    display: inline!important;
    bottom: 3px!important;
    font-size: 15px!important;
}
.list-content{
    padding-left: 33px!important;
}
.list-content li{
    list-style-type: square!important;
    display: list-item;
    font-size: 30px;
    padding-bottom: 8px!important;
    line-height: 20px;
}
.list-content li span{
    position: relative;
    display: inline;
    bottom: 3px;
    font-size: 15px;
}
.section{
  padding-top: 60px!important;
  padding-bottom: 80px!important;
}
</style>

<script>
import { mapActions } from "vuex";
import ShopConstants from '../../js/helpers/ShopConstants';

export default {
    data(){
        return {
            ShopConstants: ShopConstants
        }
    },
    methods: {
        ...mapActions({
            trackClickEvent: 'ga/trackClickEvent'
        }),
        redirect(eventName, url){
            this.trackClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title, url: url});
        }
    }
};
</script>
